export const environment = {
  // Since this is an internal app, we don't need to set production to true.
  // Keep it nice for debugging.
  production: false,
  genAi: {
    // apiKey is injected at runtime by setting window.__GENAI_KEY__ or replaced during build
    apiKey: "AIzaSyCa-yVXeurQrC6Z7c9CoSEraPq2hcn53XE",
  },
};
